import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { KYBProgressStatusEnum } from 'anchor-kyb-service/types';
import { Button, Callout } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { openInNewTabProps } from '~/constants';
import { useStore } from '~/contexts';
import { usePersonaKYBStatus } from '~/hooks/reactQuery/queries/usePersonaKYBStatus';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
import styles from './HomePage.module.scss';
export const GetMissingColumnBankAccountBannerTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            MissingColumnBankAccountBannerTID: {
                Banner: 'missing-column-bank-account-banner'
            }
        }
    });
export function MissingColumnBankAccountBanner() {
    const { t: homeTexts } = useLocaleKeys('pages.homePage');
    const showExceptKyb = useStore(selectors.showMissingColumnBankAccountBannerExceptKyb);
    const { personaKYBStatus } = usePersonaKYBStatus({
        refreshOnHookMount: true,
        enabled: showExceptKyb
    });
    const { MissingColumnBankAccountBannerTID } = useMemo(()=>GetMissingColumnBankAccountBannerTID(), []);
    return showExceptKyb && (personaKYBStatus === null || personaKYBStatus === void 0 ? void 0 : personaKYBStatus.status) === KYBProgressStatusEnum.Approved ? /*#__PURE__*/ _jsx(Callout, {
        hideIcon: true,
        intent: "warning",
        testId: MissingColumnBankAccountBannerTID.Banner(),
        className: styles.missingColumnBankAccountBanner,
        withAction: /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
            bi: {
                name: 'schedule_ach_migration_call'
            },
            as: "a",
            href: "https://book.avoma.com/anchor/3-day-ach-migration",
            skin: "monochrome"
        }, openInNewTabProps), {
            children: homeTexts.scheduleCall()
        })),
        children: homeTexts.missingColumnBankAccountMessage()
    }) : null;
}
